import { Injectable } from '@angular/core';
import {
  Action,
  NgxsAfterBootstrap,
  State,
  StateContext,
  Store,
} from '@ngxs/store';
import { retry, switchMap, tap } from 'rxjs/operators';
import { BSON } from 'realm-web';
import { InstitutionService } from '../services/institution.service';
import { AdminService } from '../services/admin.service';
import { RealmClientService } from '../../../../shared/projects/sdk/src/lib/services/realm-client.service';
import {
  AddSessionListAction,
  FetchSessionListAction,
} from '../actions/session';
import { SessionService } from '../services/session.service';
import { SESSION_LIST_STATE } from '../values/state-names';
import { Session } from '../../../../types/session';

@State<Array<Session>>({
  name: SESSION_LIST_STATE,
  defaults: [],
})
@Injectable({
  providedIn: 'root',
})
export class SessionListState implements NgxsAfterBootstrap {
  constructor(
    private _store: Store,
    private _sessionService: SessionService,
    private _institutionService: InstitutionService,
    private _adminService: AdminService,
    private _realmClientService: RealmClientService
  ) {}

  ngxsAfterBootstrap() {
    if (
      this._realmClientService?.realmClient?.currentUser?.isLoggedIn === true
    ) {
      this._store.dispatch(new FetchSessionListAction());
    }
  }

  @Action(AddSessionListAction)
  submitSessionList(
    stateContext: StateContext<Array<Session>>,
    addSessionListAction: AddSessionListAction
  ) {
    stateContext.setState([
      ...addSessionListAction.sessionList,
      ...stateContext.getState(),
    ]);
  }

  @Action(FetchSessionListAction)
  fetchClassList(stateContext: StateContext<Array<Session>>) {
    return this._adminService
      .getAdmin(this._realmClientService.realmClient.currentUser!.id)
      .pipe(
        switchMap((adminProfile) => {
          return this._institutionService.getInstitutionProfile(
            new BSON.ObjectID(adminProfile?.assigned_institution_id)
          );
        }),
        switchMap((institutionProfile) => {
          return this._sessionService.getSessionsByInstitutionList(
            institutionProfile!._id.toString()
          );
        }),
        retry(3),
        tap((sessionList) => {
          stateContext.setState([...sessionList]);
        })
      );
  }
}
